var map = {
	"./alipay_oauth2.png": "a84c",
	"./azure_ad_saml.png": "4216",
	"./azure_oidc.png": "b651",
	"./cas.png": "4aae",
	"./dex_oidc.png": "3076",
	"./dingtalk_oauth2.png": "3d825",
	"./feishu_oauth2.png": "8f82",
	"./github_oidc.png": "8f1cb",
	"./google_oidc.png": "2fcf",
	"./oidc.png": "b03a",
	"./qywechat_oauth2.png": "c6e0",
	"./saml.png": "d0b5",
	"./wechat_oauth2.png": "802e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c7f5";